import React from 'react';
import Recommendation from './recommendation';
import { recShape } from './recommendation_mapper';
import LinkedStory from './linked_story';

const InternalTrafficRecommendation = ({ rec }) => {
  const headline = 'Add more internal links';

  return (
    <Recommendation headline={headline} rec={rec}>
      {'Your traffic from internal sources is down. Consider adding one to two internal links to content like '}
      <LinkedStory
        id={rec.id}
        href={rec.primaryItem.link}
        title={rec.primaryItem.title}
      />
      {' to keep your audience engaged.'}
    </Recommendation>
  );
};

export default InternalTrafficRecommendation;

InternalTrafficRecommendation.propTypes = {
  rec: recShape.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/recommendations/internal_traffic_recommendation.jsx